<template>
  <div class="root">
    <div id="global-loader" v-show="showWaiting">
      <div class="hiturn-logo">
        <img src="@/assets/images/hiturn-waiting.png" style="width: 160px;">
      </div>
      <div style="margin-top: 50px;text-align: center;">
        <div><span style="font-size: 16px;color: #ffffff;">正在加载中...</span></div>
      </div>
    </div>
    <div class="page">
      <div class="page-main">
        <Header></Header>
        <div class="wrapper">
          <!-- Sidebar Holder -->
          <NavBar></NavBar>
          <div class="content-area">
            <TagsBar></TagsBar>
            <router-view style="min-height: 500px;" v-if="isChecking()"></router-view>
            <SubmitSuccess v-if="!isChecking() && $store.getters.enterpriseInfo.checkState==0"></SubmitSuccess>
            <SubmitFail v-if="!isChecking() && $store.getters.enterpriseInfo.checkState==2"></SubmitFail>
          </div>
        </div>
        <div class="talking-list" v-if="$store.getters.userType!='public'">
          <div class="talking-list-body" v-show="showTalkList">
            <ul class="talk-list-block">
              <li class="talk-item" @click="showInterviewModal(session)" v-for="session in talkSessions"
                  v-bind:key="session.id">
                <!--<i :class="session.onlineState==true?'fa fa-user state-icon':'fa fa-user state-icon-not'"></i>-->
            <img v-if="session.onlineState == true && $store.getters.userType=='personal'" src="https://app.hiturnjob.com/images/dh-qy.png" class="state-icon">
            <img v-if="session.onlineState == true && $store.getters.userType=='enterprise'" src="https://app.hiturnjob.com/images/dh-gr.png" class="state-icon">
            <img v-if="session.onlineState == false && $store.getters.userType=='personal'" src="https://app.hiturnjob.com/images/dh-qy-h.png" class="state-icon">
            <img v-if="session.onlineState == false && $store.getters.userType=='enterprise'" src="https://app.hiturnjob.com/images/dh-gr-h.png" class="state-icon">
            
                <span v-if="$store.getters.userType=='personal'">{{session.uname}}(<i
                  v-text="toOpenMessageNum[session.id]==null?0:toOpenMessageNum[session.id]"
                  class="message-num"></i>)</span>
                <span
                  v-if="$store.getters.userType=='enterprise'">{{session.uname}}(<i
                  v-text="toOpenMessageNum[session.id]==null?0:toOpenMessageNum[session.id]"
                  class="message-num"></i>)</span>
              </li>
            </ul>
          </div>
          <div :class="allToOpenMessageNum==0?'talking-list-head':'talking-list-head new-message'"
           @click="showTalkList = !showTalkList"><img src="@/assets/images/sy/icon-talk.png" style="width: 24px;height: 22px;margin:8px;"><span style="display: block;text-align: center;"><span style="width: 16px;display: block;margin: 0px auto;">对话列表︵</span>{{allToOpenMessageNum > 99?'99':allToOpenMessageNum}}<span style="width: 16px;display: block;margin: 0px auto;">︶</span></span></div>
        </div>
      </div>
    <SendCv ref="sendCv"></SendCv>
    <AddInterview ref="sinter" :cvId="this.targetCvId"></AddInterview>
      <!--footer-->
      <Footer></Footer>
      <!-- End Footer-->
    </div>
    <div id="enterpriseModal" class="modal fade">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content ">
          <div class="modal-body" style="padding:30px 20px">
            <div style="text-align: center">
              <div class="hint-title">
              </div>
              <div style="padding-top: 20px;padding-bottom: 20px;">
                <p>尊敬的用户您好，您尚未完成企业基本信息补充，暂时无法进行职位等功能。</p>
              </div>
            </div>
            <div style="text-align: center">
              <button class="btn btn-primary" v-on:click="closeModal">
                &nbsp;去填写企业信息&nbsp;
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div id="interviewModal" class="modal">
      <div style="position:fixed;top:60px; left:50%;margin-left: -325px;" v-if="showInterview">
        <div class="chat-box">
          <div class="chat-header">
            <span
              v-if="($store.getters.userType=='personal')">{{currentTalkSession.uname}}</span>
            <span
              v-if="($store.getters.userType=='enterprise')">{{currentTalkSession.uname}}</span>
            <i class="fa fa-close" v-on:click="closeInterview"></i>
          </div>
          <!--
          <img src="@/assets/images/profile.png" class="send-icon" v-on:click="sendCvs()"
               v-if="$store.getters.userType=='personal'"/>
          <img src="@/assets/images/interview-send.png" class="send-icon" v-on:click="sendInterviews()"
               v-if="$store.getters.userType=='enterprise'"/>-->
          <div style="clear:both;"></div>
          <JwChat
            :taleList="list"
            @enter="bindEnter"
            v-model="inputMsg"
            :toolConfig="tool"
            :width="650"
            :height="500"
            style="z-index:999;"
            :scrollType="scrollType">
            <template slot="tools">
              <div style="width:38rem;text-align:right;">
                  <i v-on:click="sendCvs()" v-if="$store.getters.userType=='personal'"  class="fa fa-send-o chat-btn" style="font-size:15px;">&nbsp;发送简历</i>
                  <i v-on:click="sendInterviews()" v-if="$store.getters.userType=='enterprise'"  class="fa fa-send-o chat-btn" style="font-size:15px;">&nbsp;邀请面试</i>
              </div>
            </template>
          </JwChat>
          <input id="file" type="file" style="display:none;" v-on:change="uploadFile">
        </div>
      </div>
    </div>
    <div id="wxModal" class="modal fade">
      <div class="modal-dialog modal-md" role="document">
        <div class="modal-content ">
          <div class="modal-header">
            <b>绑定微信</b>
          </div>
          <div class="modal-body">
            <div style="text-align: center">
              <div style="">
                <div id="wx-code"></div>
                <p>请使用微信扫描二维码，点击同意授权。</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div id="personModal" class="modal fade" data-backdrop="static"  data-keyboard="false" >
      <div class="modal-dialog" role="document" style="width:344px">
        <div class="modal-content " style="border-radius:8px;">
          <div class="modal-body pd-20">
            <div style="text-align: center">
              <div style="text-align: center">
                <div id="wx-code-new" style="height:150px;overflow:hidden"></div>
              </div>
              <div style="padding-top: 5px;padding-bottom: 20px;">
                <p style="font-size:14px;font-weight:500;">微信扫一扫并绑定，手机端可自动登录</p>
              </div>
            </div>
            <div style="text-align: center">
                <button class="btn btn-primary" @click="creatCv" style="border-radius:20px;" v-text="cvState=='0'?'创建简历':'修改简历'">创建简历
                </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div id="guildModalEnterprise" class="modal fade">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content ">
          <div class="modal-body pd-20">
            <div style="text-align: center">
              <div style="text-align: center">
                <img src="@/assets/images/hiturn.png" style="width: 180px;margin-top: 30px;">
              </div>
              <div style="padding-top: 50px;padding-bottom: 30px;">
                <p>尊敬的用户，您的账号尚未绑定微信，绑定后可直接扫码登录。</p>
              </div>
            </div>
            <div style="text-align: center">
              <button class="btn btn-primary" v-on:click="openWxLoginModal">
                去绑定
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div id="bindSuccess" class="modal fade">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content ">
          <div class="modal-body pd-20">
            <div style="text-align: center">
              <div style="text-align: center">
                <img src="@/assets/images/hiturn.png" style="width: 180px;margin-top: 30px;">
              </div>
              <div style="padding-top: 50px;padding-bottom: 30px;">
                <p>您已成功绑定微信，后期可直接微信登录。</p>
              </div>
            </div>
            <div style="text-align: center">
              <button class="btn btn-primary" v-on:click="closeSuccessModal">
                我知道了
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div id="passwordModal" class="modal fade">
      <div class="modal-dialog modal-md" role="document">
        <div class="modal-content ">
          <div class="modal-header"  style="padding:10px 20px;">
            <b>更改密码</b>
          </div>
          <div class="modal-body" style="padding: 20px 30px;">
            <div class="row" style="margin:0px">
              <form method="post" onsubmit="return false;" style="width: 100%;">
                <div  class="form-group">
                  <label>当前密码</label>
                  <input style="width: calc(100% - 80px);display: inline; margin-left: 15px;" type="password" class="form-control" placeholder="请输入当前密码" v-model="passwordUpdateRequest.currentPassword" >
                </div>
                <div  class="form-group">
                  <label class="">修改密码</label>
                  <input style="width: calc(100% - 80px);display: inline; margin-left: 15px;" type="password" class="form-control" placeholder="请输入修改密码" v-model="passwordUpdateRequest.updatePassowrd" >
                </div>
                <div class="form-group">
                  <label class="">再次输入修改密码</label>
                  <input style="width: calc(100% - 135px);display: inline; margin-left: 15px;" type="password" class="form-control " placeholder="请再次输入修改密码" v-model="passwordUpdateRequest.updatePassowrdCheck" >
                </div>
                <div class="form-group" style="    text-align: center;">
                  <button class="btn btn-primary" v-on:click="upatePassword()">确认</button>
              <button class="btn btn-gray" v-on:click="closePasswordModal()">关闭</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div id="diseaseModal" class="modal fade">
      <div class="modal-dialog modal-md" role="document">
        <div class="modal-content p-2">
          <div class="modal-body">
            <div class="row">
              <div style="font-size: 18px;">
                <img src="@/assets/images/disease_banner.png">
              </div>
              <div style="font-size: 16px;margin: 10px auto;text-align: center;">
                特殊时期，特殊情况，特殊处理!
              </div>
              <div style="font-size: 14px;margin: 10px auto;text-align: center;">
                我们在简历中加入“<span style="font-size: 16px;">微信号</span>”，以便于各位线上视频面试。
              </div>
              <div style="font-size: 14px;margin: 20px auto;">
                戴口罩、勤洗手，测体温、勤消毒，少聚集、勤通风.
              </div>
            </div>
            <div style="margin: 0px auto;text-align: center;">
              <button class="btn btn-gray" v-on:click="closeDiseaseModal()">关闭</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div id="telephoneModal" class="modal fade">
      <div class="modal-dialog modal-md" role="document">
        <div class="modal-content">
          <div class="modal-header" style="padding:10px 20px">
                    <b>更换手机</b>
          </div>
          <div class="modal-body" style="padding:20px 30px;">
            <div class="row" style="margin:0px;">
              <form method="post" onsubmit="return false;" style="width: 100%;">
                <table style="width: 100%;border:0px">
                  <tr>
                    <td>更换手机</td>
                    <td colspan="2"><input v-model="personalInfo.contactPhone" class="form-control col-24" placeholder="请输入新手机号" style="width:220px"></td>
                  </tr>
                  <tr>
                    <td>&nbsp;</td>
                  </tr>
                  <tr>
                    <td>验证码</td>
                    <td><input class="form-control" v-model="personalInfo.code" placeholder="请输入验证码" style="width:220px"></td>
                    <td style="width: 80px;text-align: right;"><a class="code-btn" @click="handleCode">{{hintInfo.buttonText}}</a> </td>
                  </tr>
                </table>
              </form>
            </div>
            <div class="form-group" style="margin-top: 20px;margin-bottom:0px;text-align: center;">
              <button class="btn btn-primary" v-on:click="upateTelephone()">确认</button>
              <button class="btn btn-gray" v-on:click="closeTelephoneModal()">关闭</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Large Modal -->
    <div id="largeModal" class="modal fade">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content ">
          <div class="modal-header pd-x-20">
            <h6 class="modal-title">外语水平</h6>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body pd-20">
            <div class="custom-controls-stacked" style="height: inherit;">
              <div class="row" style="margin: 20px">
                <label class="custom-control custom-checkbox col-lg-4" style="">
                  <input type="checkbox" class="custom-control-input" name="example-checkbox1" value="option1"
                         checked="">
                  <span class="custom-control-label">不限</span>
                </label>
                <label class="custom-control custom-checkbox col-lg-4">
                  <input type="checkbox" class="custom-control-input" name="example-checkbox2"
                         value="option2">
                  <span class="custom-control-label">英语四级</span>
                </label>
                <label class="custom-control custom-checkbox col-lg-4">
                  <input type="checkbox" class="custom-control-input" name="example-checkbox2"
                         value="option2">
                  <span class="custom-control-label">英语六级</span>
                </label>
                <label class="custom-control custom-checkbox col-lg-4">
                  <input type="checkbox" class="custom-control-input" name="example-checkbox2"
                         value="option2">
                  <span class="custom-control-label">英语专业四级</span>
                </label>
                <label class="custom-control custom-checkbox col-lg-4">
                  <input type="checkbox" class="custom-control-input" name="example-checkbox2"
                         value="option2">
                  <span class="custom-control-label">英语专业八级</span>
                </label>
                <label class="custom-control custom-checkbox col-lg-4">
                  <input type="checkbox" class="custom-control-input" name="example-checkbox2"
                         value="option2">
                  <span class="custom-control-label">英语，海外生活工作经历</span>
                </label>
                <label class="custom-control custom-checkbox col-lg-4">
                  <input type="checkbox" class="custom-control-input" name="example-checkbox2"
                         value="option2">
                  <span class="custom-control-label">日语</span>
                </label>
                <label class="custom-control custom-checkbox col-lg-4">
                  <input type="checkbox" class="custom-control-input" name="example-checkbox2"
                         value="option2">
                  <span class="custom-control-label">法语</span>
                </label>
                <label class="custom-control custom-checkbox col-lg-4">
                  <input type="checkbox" class="custom-control-input" name="example-checkbox2"
                         value="option2">
                  <span class="custom-control-label">德语</span>
                </label>
                <label class="custom-control custom-checkbox col-lg-4">
                  <input type="checkbox" class="custom-control-input" name="example-checkbox2"
                         value="option2">
                  <span class="custom-control-label">俄罗斯语</span>
                </label>
                <label class="custom-control custom-checkbox col-lg-4">
                  <input type="checkbox" class="custom-control-input" name="example-checkbox2"
                         value="option2">
                  <span class="custom-control-label">其他小语种</span>
                </label>
              </div>
            </div>
          </div><!-- modal-body -->
          <div class="modal-footer">
            <button type="button" class="btn btn-primary">确定</button>
            <button type="button" class="btn btn-secondary" data-dismiss="modal">取消</button>
          </div>
        </div>
      </div>
    </div>
    <a href="#top" id="back-to-top" style="display: inline;background-color: #9ac043 !important;"><i class="fa fa-angle-up"></i></a>
  </div>
</template>

<script>
  import Header from "@/components/Header";
  import NavBar from "@/components/NavBar";
  import TagsBar from "@/components/TagsBar";
  import Footer from "@/components/Footer";
  import {getToken} from "@/utils/auth";
  import {updatePassword} from '@/api/user';
  import {sendAliMsg,updateTelephone,upload} from '@/api/common'
  import {getTalkUserList,startTalk,getTalkHistory,onLineState} from '@/api/talk'
  import Toastr from 'toastr2'
  import SubmitSuccess from '@/views/submitSuccess'
  import SubmitFail from '@/views/SubmitFail'
  import {parseTime} from '@/utils/datetime'
  import SendCv from "@/views/fair/commons/select_cv";
  import AddInterview from "@/components/common/job/add_interview_job2";
  window.closeWxModal = function(){
    $("#wxModal").modal("hide")
  }
  window.showSuccessModal = function () {
    $("#bindSuccess").modal()
  }
  export default {
    name: "index",
    components: {SubmitSuccess, Footer, TagsBar, NavBar, Header,SendCv,AddInterview,SubmitFail},
    created(){
    },
    data(){
      return {
        showNav:true,
        showWaiting:false,
        passwordUpdateRequest:{

        },
        scrollType:'scroll',
        targetCvId: "",
        hintInfo: {
          contactPhone: '',
          buttonText: '获取验证码'
        },
        state: {
          waitMessage: false
        },
        personalInfo:{

        },
        num:0,
        showTalkList:false,
        ws:null,
        list:[
        ],
        inputMsg:'',
        toolConfig:[],
        config:{
          img: '../image/cover.png',
          name: 'JwChat',
          dept: '最简单、最便捷',
          callback: this.bindCover
        },
        talk:[],
        rightConfig:{},
        tool:{
          show: ['img'],
          callback: this.toolEvent,
          showEmoji: false
        },
        userId:null,
        showInterview:false,
        talkSessions:[],
        currentTalkSession:null,
        toOpenMessageNum:{

        },
        allToOpenMessageNum:0,
        cvState:0
      }
    },
    mounted() {
      $(".nav-sidebar").mCustomScrollbar({
        theme:"minimal",
        autoHideScrollbar: true,
        scrollbarPosition: "outside"
      });
      let _this = this
      this.$store.dispatch("user/checkInfoFill")
      this.initWS()
      //this.openDiseaseModal()
      /*
      setTimeout(function(){
        _this.showWaiting = false
        _this.$store.dispatch("user/checkInfoFill")
      },600)
      */
      //$("#global-loader").modal()

      this.cvState=this.$store.getters.userInfo.cvState;
    },
    computed:{

    },
    methods:{
      creatCv(){
        $("#personModal").modal('hide')
        var cvId=this.$store.getters.userInfo.cvId;
        if(this.cvState=='0' && cvId!=null && cvId!=''){
          this.$router.push({
            path:'/cv/cv_edit/base_info_edit?from=add'
          })
        }else{
          this.$router.push({
              path: '/cv/cv_edit/base_info_edit',
              query:{basicId:cvId,from:"edit"}
          })
        }
      },
      bindClick:function(){

      },
      closeModal:function(){
        $("#enterpriseModal").modal("hide");
        this.$router.push({
          path:'/enterprise/enterprise_info_view'
        })
      },
      sendCvs() {
        var tid = localStorage.getItem('targetJobId')
        this.$refs.sendCv.getMyCvs(tid);
        this.closeInterview()
        
        $('#selectSendCv').modal('show');
      },
      sendInterviews() {
        const enterpriseInfo = this.$store.getters.enterpriseInfo
        if (enterpriseInfo != null) {
          let id = enterpriseInfo.id;
          this.$refs.sinter.getPubJob(id);
          this.$refs.sinter.getEntInfo(id);
        }
          var tid = localStorage.getItem('targetCvId')
          this.targetCvId = tid
          this.closeInterview()
          $('#addInterviewByJobModal').modal('show');
      },
      showInterviewModal: function (session) {
                console.log(JSON.stringify(session))
                this.currentTalkSession = session
                const token = getToken()
                const msg = {
                  action:'ensureMessage',
                  sessionId:session.id,
                  accessToken:token
                }
                this.ws.send(JSON.stringify(msg))
                const num = this.toOpenMessageNum[session.id]
                this.toOpenMessageNum[session.id] = 0
                if(num!=null){
                  this.allToOpenMessageNum -= num
                }
                getTalkHistory({id: session.id}).then(response => {
                    const messages = response.messages
                    const list = []
                    for (let i = messages.length - 1; i >= 0; i--) {
                        const message = messages[i];
                        if(message.messageType==0){
                          continue
                        }
                        let content = {
                            'text': {"text": message.messageContent},
                            'img': "http://app.hiturnjob.com/images/hiturn-tx.gif"
                        }
                        if(message.messageDirection == "u1-e"){
                          content['img'] = "http://app.hiturnjob.com/images/dh-gr.png"
                        }else if(message.messageDirection == "e-u1"){
                          content['img'] = "http://app.hiturnjob.com/images/dh-qy.png"
                        }
                        const userType = this.$store.getters.userType
                        if (userType == "personal" && message.messageDirection == "u1-e") {
                            content['mine'] = true
                            content['name'] = this.$store.getters.userInfo.username
                        }
                        if (userType == "personal" && message.messageDirection == "e-u1") {
                            content['mine'] = false
                            content['name'] = this.currentTalkSession.uname
                        }
                        if (userType == "enterprise" && message.messageDirection == "u1-e") {
                            content['mine'] = false
                            content['name'] = this.currentTalkSession.uname
                        }
                        if (userType == "enterprise" && message.messageDirection == "e-u1") {
                            content['mine'] = true
                            content['name'] = this.$store.getters.enterpriseInfo.enterpriseName
                        }
                        let time = new Date(message.sendTime)
                        content['date'] = parseTime(time)
                        list.push(content)
                    }
                    this.list = list
                    $("#interviewModal").modal()
                    this.showInterview = true
                    
                })
            },
            closeInterview: function () {
                $("#interviewModal").modal('hide')
                this.showInterview = false
                this.currentTalkSession = null
            },
      openWxLoginModal:function(){
        $("#personModal").modal("hide");
        $("#wxModal").modal();
        let token = getToken()
        let userId = this.$store.getters.userInfo.id
        let type = this.$store.getters.userType
        var obj = new WxLogin({
          self_redirect:true,
          id:"wx-code",
          appid: "wx29326039d5664095",
          scope: "snsapi_login",
          redirect_uri: encodeURIComponent("https://app.hiturnjob.com/wxUnion.html?&type=" + type +"&token=" + token + "&method=bind"),
          state: "checked",
          style: "white",
          href: "https://www.hiturnjob.com/qc1.css"
        });
      },
      isChecking:function() {
        if (this.$store.getters.userType == 'enterprise') {
          let checkState = this.$store.getters.enterpriseInfo.checkState
          let path = this.$route.fullPath
          if (path=='/enterprise/enterprise_info_detail' || path=='/enterprise/enterprise_info_view' || path=='/ability/enterprise_manage') {
            return true
          }else {
            if (checkState != 1) {
              return false
            }
          }
        }
        return true
      },
      openDiseaseModal:function(){
        $("#diseaseModal").modal()
      },
      closeSuccessModal:function () {
        $("#bindSuccess").modal("hide")
      },
      upatePassword:function(){
        if (this.passwordUpdateRequest.updatePassowrd!=this.passwordUpdateRequest.updatePassowrdCheck){
          const toast = new Toastr()
          toast.warning("用户修改密码不一致")
        }else{
          updatePassword(this.passwordUpdateRequest).then(response => {
            const toast = new Toastr()
            toast.success("修改成功")
            $("#passwordModal").modal("hide")
          }).catch(err=>{
            console.log(err)
            toast.warning("修改失败")
            $("#passwordModal").modal("hide")
          })
        }
      },
      handleCode: function() {
        const toastr = new Toastr()
        if (!this.state.waitMessage) {
          let contactPhone = this.personalInfo.contactPhone
          if (contactPhone != null) {
            let data = {
              phoneNumbers: contactPhone
            };
            this.state.waitMessage = true;
            let time = 60;
            let this_ = this;
            let interval = setInterval(function() {
              if (time < 1) {
                this_.hintInfo.buttonText = '获取验证码';
                this_.state.waitMessage = false;
                window.clearInterval(interval);
              } else {
                time--;
                this_.hintInfo.buttonText = time + ' s ';
              }
            }, 1000)
            sendAliMsg(data).then(response => {
              toastr.success("短信已发送")
            }).catch(error => { // 请求失败处理
              window.clearInterval(interval);
              toastr.warning("短信发送失败")
              this.hintInfo.buttonText = '获取证码';
              this.state.waitMessage = false
              console.log(error)
            })
          } else {
            toastr.warning("请输入正确的手机号");
          }
        }
      },
      upateTelephone:function () {

        const toastr = new Toastr()
        if (this.personalInfo.contactPhone==null || this.personalInfo.contactPhone==''){
          toastr.warning('请输入新电话');
          return false
        }
        if (this.personalInfo.code==null || this.personalInfo.code==''){
          toastr.warning('请输入验证码');
          return false
        }
        let data = {
          telephone:this.personalInfo.contactPhone,
          code:this.personalInfo.code
        }
        updateTelephone(data).then(response => {
          $("#telephoneModal").modal("hide")
          toastr.success("手机号码已更新")
        })

      },
      closeDiseaseModal:function(){
        $("#diseaseModal").modal("hide")
      },
      closeTelephoneModal:function(){
        $("#telephoneModal").modal("hide")
      },
      closePasswordModal:function(){
        $("#passwordModal").modal("hide")
      },
      bindEnter: function () {
                if (this.inputMsg != null && this.inputMsg != '') {
                    let name = ''
                    let content = {
                        'text': {"text": this.inputMsg},
                        'img': "http://app.hiturnjob.com/images/hiturn-tx.gif"
                    }
                    const userType = this.$store.getters.userType
                    let direction = "";
                    let to = this.currentTalkSession.uid
                    if (userType == "personal") {
                        direction = "u1-e"
                        content['name'] = this.$store.getters.userInfo.username
                        content['img'] = "http://app.hiturnjob.com/images/dh-gr.png"
                    }
                    if (userType == "enterprise") {
                        direction = "e-u1"
                        content['name'] = this.$store.getters.enterpriseInfo.enterpriseName
                        content['img'] = "http://app.hiturnjob.com/images/dh-qy.png"
                    }
                    let from
                    if(this.$store.getters.userType=='personal'){
                      from = this.$store.getters.userInfo.id
                    }
                    if(this.$store.getters.userType=='enterprise'){
                      from = this.$store.getters.enterpriseInfo.id
                    }
                    const msg = {
                        action: 'p2pTalk',
                        type: 1,
                        direction: direction,
                        to: to,
                        from:from,
                        content: content,
                        sessionId: this.currentTalkSession.id
                    }
                    this.ws.send(JSON.stringify(msg))
                    content['mine'] = true
                    content['date'] = parseTime(new Date())
                    this.list.push(content)
                }
            },
      rightClick:function(){

      },
      toolEvent:function(type){
        if(type == 'file'){
          document.getElementById('file').click()
        }
        if(type == 'img'){
          document.getElementById('file').click()

        }
        if(type == 'more'){
          if(this.$store.getters.userType=='personal'){
            this.sendCvs()
          }
          if($store.getters.userType=='enterprise'){
            this.sendInterviews()
          }
        }
      },
      uploadFile:function(){

                upload('file').then(response => {
                    const path = response.path
                    const contentSrc = "<img data-src='" + path + "' src='" + path + "' style='width:100%;'>"
                    let content = {
                        'text': {"text": contentSrc},
                        'img': "https://app.hiturnjob.com/images/hiturn-tx.gif"
                    }
                    const userType = this.$store.getters.userType
                    let direction = "";
                    let to = ""
                    if (userType == "personal") {
                        direction = "u1-e"
                        content['name'] = this.$store.getters.userInfo.username
                        to = this.currentTalkSession.uid
                        content['img'] = "http://app.hiturnjob.com/images/dh-gr.png"
                    }
                    if (userType == "enterprise") {
                        direction = "e-u1"
                        to = this.currentTalkSession.uid
                        content['name'] = this.$store.getters.enterpriseInfo.enterpriseName
                        content['img'] = "http://app.hiturnjob.com/images/dh-qy.png"
                    }
                    const msg = {
                        action: 'p2pTalk',
                        type: 3,
                        direction: direction,
                        to: to,
                        content: content,
                        sessionId: this.currentTalkSession.id
                    }
                    this.ws.send(JSON.stringify(msg))
                    content['mine'] = true
                    content['date'] = parseTime(new Date())
                    this.list.push(content)
                })
      },
      bindCover:function(play){
        console.log('user', play)
      },
      initWS: function () {
                const accessToken = getToken()
                const this_ = this
                if ("WebSocket" in window) {
                    // 打开一个 web socket
                    let ws = new WebSocket("wss://admin.hiturnjob.com:10086/talk");
                    ws.onopen = function () {
                        const loginMessage = {
                            action: 'login',
                            accessToken: accessToken
                        }
                        ws.send(JSON.stringify(loginMessage))
                        const loadUnReadMessage = {
                            action: 'loadUnRead',
                            accessToken: accessToken
                        }
                        this_.ws.send(JSON.stringify(loadUnReadMessage))
                    }
                    ws.onmessage = function (evt) {
                        var msg = JSON.parse(evt.data);
                        if(msg.action == 'p2pTalk'){
                          if(msg.otherDevice){
                            const sessionId = msg.sessionId
                            if (this_.currentTalkSession != null && this_.currentTalkSession.id == sessionId) {
                              msg.content['mine'] = true
                              this_.list.push(msg.content)
                            }
                          }else{
                            const sessionId = msg.sessionId
                            if (this_.currentTalkSession != null && this_.currentTalkSession.id == sessionId) {
                                msg['mine'] = false
                                this_.list.push(msg)
                                const token = getToken()
                                const relaseMsg = {
                                  action:'ensureMessage',
                                  sessionId:sessionId,
                                  accessToken:token
                                }
                                this_.ws.send(JSON.stringify(relaseMsg))
                            }
                            if (this_.currentTalkSession == null || this_.currentTalkSession.id != sessionId) {
                                if(this_.toOpenMessageNum[sessionId]!=null){
                                  this_.toOpenMessageNum[sessionId] += 1
                                }else{
                                  this_.toOpenMessageNum[sessionId] = 1
                                }
                                this_.allToOpenMessageNum += 1
                            }
                            for (let i = 0; i < this_.talkSessions.length; i++) {
                                const session = this_.talkSessions[i]
                                if (sessionId == session.id) {
                                    session['sendTime'] = new Date(msg.date.replace(/-/g, '/'))
                                    this_.talkSessions[i] = session
                                    break
                                }
                            }
                            this_.sortSession()
                          }
                        }
                        
                        if(msg.action == 'enterpriseOnLineStateBroadcast'){
                          const toastr = new Toastr()
                          const enterpriseName = msg['enterpriseName']
                          const sessionId = msg['sessionId']
                          console.log(sessionId)
                          for(let i=0;i<this_.talkSessions.length;i++){
                            
                            if(this_.talkSessions[i].id == sessionId){
                              console.log(this_.talkSessions[i].onlineState + '状态变更')
                              if(msg['onLine']){
                                this_.talkSessions[i].onlineState = true
                              }
                              if(!msg['onLine']){
                                this_.talkSessions[i].onlineState = false
                              }
                              break
                            }
                          }
                          if(msg['onLine']){
                            //toastr.info(enterpriseName + '已上线')
                          }
                          if(!msg['onLine']){
                            //toastr.info(enterpriseName + '已离线')
                          }
                          this_.sortSession()
                        }
                        if(msg.action == 'userOnLineStateBroadcast'){
                          const toastr = new Toastr()
                          const user1Name = msg['user1Name']
                          const sessionId = msg['sessionId']
                          for(let i=0;i<this_.talkSessions.length;i++){
                            if(this_.talkSessions[i].id == sessionId){
                              if(msg['onLine']){
                                this_.talkSessions[i].onlineState = true
                              }
                              if(!msg['onLine']){
                                this_.talkSessions[i].onlineState = false
                              }
                              console.log(this_.talkSessions[i].onlineState)
                              break
                            }
                          }
                          if(msg['onLine']){
                            //toastr.info(user1Name + '已上线')
                          }
                          if(!msg['onLine']){
                            //toastr.info(user1Name + '已离线')
                          }
                          this_.sortSession()
                        }
                        if(msg.action == 'updateUserList'){
                          const relationMap = msg['list']
                          const sessions = []
                          for(let key in relationMap){
                            sessions.push(JSON.parse(relationMap[key]))
                          }
                          this_.talkSessions = sessions
                          this_.sortSession()
                        }
                        if(msg.action == 'tok'){

                        }
                    }
                    ws.onclose = function () {
                        const loginMessage = {
                            action: 'logout',
                            accessToken: accessToken
                        }
                        ws.send(JSON.stringify(loginMessage))
                    }
                    this.ws = ws
                    window.onbeforeunload = function () {
                        const logoutMessage = {
                            action: 'logout',
                            accessToken: accessToken
                        }
                        this_.ws.send(JSON.stringify(logoutMessage))
                    }
                    
                    setInterval(() => {
                        const tikMessage = {
                            action: 'tik'
                        }
                        this_.ws.send(JSON.stringify(tikMessage))
                        /*
                        onLineState({}).then(response => {
                            const ids = response.onLineIds
                            for (let i = 0; i < this_.talkSessions.length; i++) {
                                const userType = this_.$store.getters.userType
                                this_.talkSessions[i].onlineState = 0
                                if (userType == "personal") {
                                    if (ids[this_.talkSessions[i].enterpriseId] != null) {
                                        this_.talkSessions[i].onlineState = 1
                                    }
                                }
                                if (userType == "enterprise") {
                                    if (ids[this_.talkSessions[i].user1Id] != null) {
                                        this_.talkSessions[i].onlineState = 1
                                    }
                                }
                            }
                        })*/
                    }, 15000);
                    /*
                    getTalkUserList({}).then(response => {
                        this.talkSessions = response.sessions
                        for (let i = 0; i < this.talkSessions.length; i++) {
                            let session = this.talkSessions[i];
                            this.toOpenMessageNum[session.id] = 0
                        }
                    })*/
                } else {
                    alert("您的浏览器支持 WebSocket!")
                }
            },
      sortSession(){
                let onLineQueue = []
                let offLineQueue = []
                for(let i=0;i<this.talkSessions.length;i++){
                  const session = this.talkSessions[i]
                  if(session.onlineState){
                    if(onLineQueue.length>0){
                      for(let j=0;j<onLineQueue.length;j++){
                        let queueSession = onLineQueue[j]
                        let lastSendTime = new Date(queueSession.lastSendTime)
                        let sessionTime = new Date(session.lastSendTime).getTime()
                        if(sessionTime<lastSendTime){
                          onLineQueue.splice(j,0,session)
                          break
                        }else{
                          if(j==onLineQueue.length-1){
                            onLineQueue.push(session)
                            break
                          }
                        }
                      }
                    }else{
                      onLineQueue.push(session)
                    }
                  }else{
                    if(offLineQueue.length>0){
                      for(let j=0;j<offLineQueue.length;j++){
                        let queueSession = offLineQueue[j]
                        let lastSendTime = new Date(queueSession.lastSendTime).getTime()
                        let sessionTime = new Date(session.lastSendTime).getTime()
                        if(sessionTime<lastSendTime){
                          offLineQueue.splice(j,0,session)
                          break
                        }else{
                          if(j==offLineQueue.length-1){
                            offLineQueue.push(session)
                            break
                          }
                        }
                      }
                    }else{
                      offLineQueue.push(session)
                    }
                  }
                }
                const onlineSort = onLineQueue.reverse()
                const offlineSort = offLineQueue.reverse()
                this.talkSessions = onlineSort.concat(offlineSort)
            },
            startTalk(sessionType, to, sourceId) {
                startTalk({sessionType: sessionType, to: to, sourceType: 'fair', sourceId: sourceId}).then(response => {
                    const accessToken = getToken()
                    const msg = {
                      action:'sendHelloMessage',
                      accessToken:accessToken,
                      sessionId:response.session.id
                    }
                    this.ws.send(JSON.stringify(msg))
                    this.showInterviewModal(response.session)
                })
            }
    }
  }

</script>

<style scoped>
/deep/ .old-template .main .loginPanel .title{
  display: none;
}
  .wrapper {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: stretch;
    -ms-flex-align: stretch;
    align-items: stretch;
  }
  .hiturn-logo{
    margin-top: 140px;
    text-align: center;
    -webkit-animation:route-animation 3s linear infinite;
  }
  .content-area {
    width: 100%;
    padding: 0 30px;
    padding-bottom: 10px;
    overflow:hidden;
    position: relative;
  }
  .hint-title{
    background-image: url("../assets/images/logobanner.jpg");
    background-size: 100% 100%;
    /* background-position: 0 180px; */
    height: 150px;
    width: 300px;
    margin:0 auto;
  }
  @-webkit-keyframes route-animation{
    0%{-webkit-transform:rotate(0deg);}
    25%{-webkit-transform:rotate(90deg);}
    50%{-webkit-transform:rotate(180deg);}
    75%{-webkit-transform:rotate(270deg);}
    100%{-webkit-transform:rotate(360deg);}
  }
  .modal-md {
    max-width: 450px;
  }
  .code-btn{
    color: #aaaaaa !important;
  }
  .code-btn:hover{
    color: #0d97de !important;
    cursor: pointer;
  }
  .talking-list {
    position: fixed;
    top: 160px;
    right: 0px;
    height: 450px;
  }

  .talking-list-body {
    border: 1px solid #ddd;
    width: 300px;
    height: 100%;
    float: right;
    background: #fff;
    text-align: left;
    overflow-y: scroll;
  }

  .talking-list-head {
    width: 40px;
    /* height: 180px; */
    float: right;
    /* background: #8ab734; */
    background: #d8d8d8;
    /* padding: 8px; */
    margin-top: 100px;
    cursor: pointer;
    border-radius: 5px;
  }

  .talking-list-head span {
    font-size: 16px;
    color: #ffffff;
  }

  .list-header {
    background: #97d1f8;
    color: #ffffff;
    font-size: 14px;
    text-align: center;
    height: 30px;
    line-height: 30px;
    font-weight: 400;
  }

  .talk-list-block {
    padding: 10px;
  }

  .talk-list-block li {
    border-bottom: 1px dashed #dddddd;
    padding-top: 10px;
    padding-bottom: 10px;
    cursor: pointer;
    padding-left: 5px;
  }

  .talk-list-block li:hover {
    background: #d5e4be;
  }

  .talk-list-block .state-icon {
    font-size: 18px;
    color: #2ca8ff;
    width: 18px;
    height: 18px;
  }

  .talk-list-block span {
    font-size: 14px;
    margin-left: 10px;
  }

  .interview-modal {
    position: absolute;
    margin: 200px auto;
  }

  .web__tools dl {
    display: block !important;
    margin-block-start: 1em !important;
    margin-block-end: 1em !important;
    margin-inline-start: 0px !important;
    margin-inline-end: 0px !important;
  }

  .chat-box {
    width: 650px;
    height: 550px;
    border: 1px solid #dddddd;
    margin: 10px auto;
    box-shadow: 2px 2px 2px #eeeeee;
  }

  .chat-header {
    background: #ffffff;
    height: 50px;
    position: relative;
    box-shadow: 0px 3px 5px #dddddd;
    z-index: 1000;
  }

  .chat-header img {
    position: absolute;
    width: 30px;
    height: 30px;
    top: 10px;
    left: 10px;
  }

  .chat-header span {
    position: absolute;
    top: 15px;
    left: 10px;
    color: #666666;
    font-weight: 400;
  }

  .chat-header i {
    position: absolute;
    right: 10px;
    top: 15px;
    color: #888888;
    font-size: 22px;
    cursor: pointer;
    font-weight: 100;
  }

  .message-num {
    font-size: 14px;
    color: #222222;
    font-weight: 200;
    font-style: normal;
  }

  @keyframes blink {
    from {
      background: #7db919;
    }
    to {
      background: #db6e08;
    }
  }

  @-webkit-keyframes blink {
    from {
      background: #7db919;
    }
    to {
      background: #db6e08;
    }
  }

  .new-message {
    /* animation: blink 1s infinite;
    -moz-animation: blink 1s infinite;
    -webkit-animation: blink 1s infinite; */

    background: #8ab734;
  }

  .talk-list-block .state-icon-not {
    font-size: 18px;
    color: #eeeeee;
  }

  .send-icon {
    width: 60px;
    height: 60px;
    position: absolute;
    top: 60px;
    left: 10px;
    z-index: 9990;
  }
  .profile-btn{
    width: 60px;height: 60px;position: fixed;border-radius: 30px;background: #FFFFFF;z-index: 999;top: 10px;left: 20px;border: 1px solid #EEEEEE;
  }
  .profile-btn img{
    width: 60px;height: 60px;
  }
  .chat-btn{
    margin-left:5px;
    font-size:14px;
    cursor:pointer;
  }
  .chat-btn:hover{
    color:#1da1f8;
  }
  .web__main-text{
    background-color:#f8b62b !important;
  }
  button{
    width:100px;height: 30px;line-height: 30px;padding:0px;text-align: center;
  }

  /deep/ #wx-code iframe{max-height: 215px;}
</style>



// WEBPACK FOOTER //
// src/layout/index.vue